/* Used by Storefront */

import React from "react";
import { FeaturedCategory, FeaturedCategoryGrandChildren } from "~/common/Store/models/Category";
import getCategoryImageUrl from "./getSeoCategoryImageUrl";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
interface Props {
  featuredChild: FeaturedCategory;
  categoryName: string;
  actionWord: string;
  showActionButton: boolean;
}
const GridLayout = ({
  featuredChild,
  categoryName,
  actionWord,
  showActionButton
}: Props) => {
  const {
    childCount,
    childType,
    categoryId
  } = featuredChild;
  const allowNavigatingToChildCategory = categoryId > 0;
  const singlarOrPluralChildType = (() => {
    const singularVersionNeeded = childCount === 1;
    if (singularVersionNeeded) {
      if (childType === "Categories") {
        return "Category";
      }
      if (childType === "Products") {
        return "Product";
      }
    }
    return childType;
  })();
  return <>
      <span className="flex items-center overflow-hidden p-3 gap-4 grid-item grid-parent">
        {allowNavigatingToChildCategory ? <a className="xl:block xl:flex-none xl:w-fit w-full flex items-center justify-center" href={featuredChild.url} title={featuredChild.name}>
            <NoScriptLazyImage className="max-w-none" src={getCategoryImageUrl(featuredChild.image)} height={170} width={170} alt={featuredChild.name} />
          </a> : <div className="block">
            <NoScriptLazyImage className="max-w-none" src={getCategoryImageUrl(featuredChild.image)} height={170} width={170} alt={featuredChild.name} />
          </div>}
        <span className="box-border xl:block xs:p-4 flex xl:w-fit w-full flex-col items-center justify-center">
          {showActionButton && allowNavigatingToChildCategory ? <a href={featuredChild.url}>
              <h2 className="font-semibold text-2xl leading-none mb-2 text-center xl:text-left">
                {featuredChild.name}
              </h2>
            </a> : <h2 className="font-semibold text-2xl leading-none  mb-2 text-center xs:text-left">
              {featuredChild.name}
            </h2>}
          {showActionButton && allowNavigatingToChildCategory && <div className="xl:block xl:float-left flex flex-col justify-center items-center xl:w-fit w-full">
              <a href={featuredChild.url} className="btn btn-small btn-info" data-testid="subCategoryButton">
                {`${actionWord}${actionWord ? " " : ""}${featuredChild.name || categoryName}`}
              </a>
              {childCount > 0 && <p className="font-normal text-2xs leading-none mb-0 mt-2 text-center uppercase text-gray-800">
                  {`${childCount} ${singlarOrPluralChildType}`}
                </p>}
            </div>}
        </span>
      </span>
      {featuredChild.featuredGrandchildren && <div className="w-full grid-children">
          {featuredChild.featuredGrandchildren.map((featuredGrandChild: FeaturedCategoryGrandChildren) => <a href={featuredGrandChild.url} className="flex-shrink min-w-0 w-full grid-item grid-child" key={`${featuredGrandChild.name} ${featuredGrandChild.categoryId}`}>
                <NoScriptLazyImage height={76} width={76} className="mb-0" src={featuredGrandChild.image.replace("_sm", "_tn")} alt={featuredGrandChild.name} />
                <span className="font-semibold text-xs leading-none mt-2 overflow-hidden px-1 w-full" style={{
          maxHeight: "36px"
        }}>
                  {featuredGrandChild.name}
                </span>
              </a>)}
        </div>}
    </>;
};
export default GridLayout;